import { useEffect, useState } from 'react'
import Bugsnag from '@bugsnag/js'
import {
  setGlobalEventProperty,
  trackInAmplitude
} from 'utils/tracking/amplitude'
import {
  AmplitudeEvent,
  EventProperty
} from 'utils/tracking/amplitude/amplitude.interface'
import { sendAffiliateEvent, AffiliateEventName } from 'utils/affiliate'
import useStore from 'stores/utils/hooks/useStore'
import { getPageNameFromPath } from 'utils/pages'
import { PageName } from 'stores/initialization/navigationInitialization/Navigation.interface'

export const usePageTracking = (
  onPageChange?: (page: string | PageName) => void
) => {
  const rootStore = useStore()
  const { traversal, history } = useStore()
  const [currentPage, setCurrentPage] = useState<string | undefined | PageName>(
    undefined
  )

  useEffect(() => {
    const unlisten = history.listen(({ location }) => {
      const currentPageName = getPageNameFromPath(location.pathname)
      setCurrentPage(currentPageName)

      // Call the optional callback for additional page change handling
      if (onPageChange && currentPageName) {
        onPageChange(currentPageName)
      }
    })

    return unlisten
  }, [history, onPageChange])

  useEffect(() => {
    if (currentPage) {
      Bugsnag.setContext(currentPage)
      setGlobalEventProperty(EventProperty.CurrentPage, currentPage)
      trackInAmplitude(AmplitudeEvent.ViewPage)
      sendAffiliateEvent(AffiliateEventName.Pageview, traversal, rootStore)
    }
  }, [currentPage, rootStore, traversal])

  return { currentPage, setCurrentPage }
}
